import { twMerge } from "tailwind-merge";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  H4,
  H6,
} from "@sellar-io/components";
import { Icon, SpinnerLegacy } from "../../../components";
import { NavigationBarMenu } from "../../../components/navigation/NavigationBar";
import { ORDER_BUYER } from "../../../constants/routes";
import { useSupplier } from "../../../hooks/api/v2/supplier/useSupplier";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { StorefrontSettingsAnnouncementBannerCard } from "./StorefrontSettingsAnnouncementBannerCard";
import { StorefrontSettingsDeliveryNotesCard } from "./StorefrontSettingsDeliveryNotesCard";
import { StorefrontSettingsDescriptionCard } from "./StorefrontSettingsDescriptionCard";

export const StorefrontContent = () => {
  const { business } = useSellarCurrentBusiness();

  if (!business?.Supplier) throw new Error("Cannot find supplier");

  const supplierQuery = useSupplier(business.Supplier.id);

  return (
    <>
      <NavigationBarMenu title={"Content"} />
      <div className={"m-auto flex max-w-[900px] flex-col gap-6 p-4"}>
        {supplierQuery.isPending ? (
          <SpinnerLegacy />
        ) : supplierQuery.isError ? (
          <div>Something went wrong</div>
        ) : (
          <>
            <Card className="bg-white">
              <CardHeader
                className={twMerge(
                  "bg-white",
                  "flex items-center justify-between gap-6 p-4",
                )}
              >
                <div>
                  <H4>Your storefront URL</H4>
                  <H6>
                    Bring customer to your trade store by linking on your
                    website and socials.
                  </H6>
                </div>
                <Button
                  color={"primary"}
                  onClick={() =>
                    navigator.clipboard.writeText(
                      `${import.meta.env.VITE_URL}${ORDER_BUYER.href({
                        supplierIdOrUrlId: supplierQuery.data.urlId,
                      })}`,
                    )
                  }
                >
                  <Icon icon={"CONTENT_COPY"} />
                  Copy
                </Button>
              </CardHeader>
              <CardContent className={"p-4 break-all"}>
                {`${import.meta.env.VITE_URL}${ORDER_BUYER.href({
                  supplierIdOrUrlId: supplierQuery.data.urlId,
                })}`}
              </CardContent>
            </Card>
            <StorefrontSettingsAnnouncementBannerCard
              supplierAnnouncement={supplierQuery.data.SupplierAnnouncement}
            />
            <StorefrontSettingsDescriptionCard
              description={supplierQuery.data.description}
            />
            <StorefrontSettingsDeliveryNotesCard
              deliveryNotes={supplierQuery.data.deliveryNotes}
            />
          </>
        )}
      </div>
    </>
  );
};
